// Prismic
let Prismic = require("prismic-javascript");

let apiEndpoint = "https://olivier-geffard.prismic.io/api/v2";

Prismic.getApi(apiEndpoint)
  .then(function (api) {
    return api.getByID("Xi12gRAAACEA9fyE"); // An empty query will return all the documents
  })
  .then(
    function (response) {
      // Add title
      const title = document.querySelector("h2");
      title.innerHTML = response.data.title[0].text;

      // Add products
      const $gallery = document.querySelector(".gallery");
      response.data.gallery.forEach((line) => {
        const $line = document.createElement("div");
        $line.classList.add("line");

        Object.keys(line).forEach((product) => {
          if (line[product].url) {
            const img = document.createElement("img");
            img.setAttribute("src", line[product].url);
            img.setAttribute("alt", line[product].alt);
            $line.appendChild(img);
          }
        });

        $gallery.appendChild($line);
      });

      // Add texts
      const priceDiv = document.querySelector(".prix");
      response.data.description.forEach((paragraphe) => {
        let conteneur = document.createElement("p");
        if (paragraphe.spans.length > 0) {
          let text = paragraphe.text;
          paragraphe.spans.forEach((span, index) => {
            if (span.type == "strong") {
              let spanConteneur = document.createElement("span");
              spanConteneur.classList.add("bold");
              let spanConteneurText = paragraphe.text.substring(
                span.start,
                span.end
              );
              spanConteneurText =
                spanConteneurText.slice(0, 1) +
                spanConteneurText.slice(1).replace(/\n/g, "<br />");
              spanConteneur.innerHTML = spanConteneurText;
              if (index == 0) {
                conteneur.innerHTML = text.slice(0, span.start);
              } else {
                conteneur.insertAdjacentHTML(
                  "beforeend",
                  text.slice(paragraphe.spans[index - 1].end, span.start)
                );
              }
              conteneur.appendChild(spanConteneur);
              if (index == paragraphe.spans.length - 1) {
                conteneur.insertAdjacentHTML(
                  "beforeend",
                  text.slice(span.end).replace(/\n/g, "<br />")
                );
              } else {
                conteneur.insertAdjacentHTML(
                  "beforeend",
                  text.slice(span.end, paragraphe.spans[index + 1].start)
                );
              }
            } else if (span.type == "hyperlink") {
              let link = document.createElement("a");
              link.setAttribute("href", span.data.url);
              link.innerHTML = paragraphe.text.substring(span.start, span.end);
              conteneur.appendChild(link);
            }
          });
          priceDiv.appendChild(conteneur);
        } else {
          conteneur.innerHTML = paragraphe.text;
          priceDiv.appendChild(conteneur);
        }
      });
    },
    function (err) {
      console.log("Something went wrong: ", err);
    }
  );
